// extracted by mini-css-extract-plugin
export default {"container":"DocTree_container__YdRRe","infoIcon":"DocTree_infoIcon__lTXbc","infoBox":"DocTree_infoBox__UVIij","empty":"DocTree_empty__uxc0O font-md-regular"};